var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mt-4",attrs:{"outlined":""}},[_c('div',{ref:"map",staticClass:"map"}),(_vm.map)?_c('MapLegend',{attrs:{"map":_vm.map,"markers":_vm.markers},on:{"apply-filter":_vm.applyFilterToMap}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }